<!-- TrustBox widget - Micro Combo -->
<div class="md:w-[25rem]">
    <div
        #trustbox
        id="trustbox"
        [ngClass]="cssClasses"
        data-locale="en-GB"
        data-template-id="5419b6ffb0d04a076446a9af"
        data-businessunit-id="587ca9720000ff00059adf3e"
        data-style-height="24px"
        data-style-width="100%">
        <a
            href="https://uk.trustpilot.com/review/followalice.com"
            target="_blank"
            rel="noopener"
            >Trustpilot</a
        >
    </div>
</div>
<!-- End TrustBox widget -->
